export const dynamicLoadingErrorMessages = [
  'error loading dynamically imported module',
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
];
